import { render, staticRenderFns } from "./PreviewVideo.vue?vue&type=template&id=54283a05&scoped=true"
import script from "./PreviewVideo.vue?vue&type=script&lang=js"
export * from "./PreviewVideo.vue?vue&type=script&lang=js"
import style0 from "./PreviewVideo.vue?vue&type=style&index=0&id=54283a05&prod&lang=less&scoped=true"
import style1 from "./PreviewVideo.vue?vue&type=style&index=1&id=54283a05&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54283a05",
  null
  
)

export default component.exports